import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";

function EditButton(props) {
  return (
    <IconButton
      aria-label={props.title || "Edit"}
      title={props.title || "Edit"}
      onClick={(e) => {
        if (props.onClick) return props.onClick(e);
        if (props.handleOpen) return props.handleOpen(e);
        if (props.handleOpen2) return props.handleOpen2(e);
      }}
      style={{ backgroundColor: "#168f02", color: "white" }}
    >
      <EditIcon style={{ color: "white" }} />
    </IconButton>
  );
}

export default EditButton;
